import { Box } from "@mui/material"
import { useEffect } from "react"
import { useScheduleEditorIds } from "./hooks/use-schedule-editor-ids"
import { ensureStyleGuideAnalysis } from "./controller/ensure-style-guide-analysis"
import { useAuthoringRecommendationSummaryFromContext } from "./hooks/use-authoring-recommendation-summary"

export function AuthoringRecommendationsTitle() {
    const { projectId, scheduleId } = useScheduleEditorIds()
    const { summary, refetchRecommendations } = useAuthoringRecommendationSummaryFromContext()
    const badgeContent = summary.counts.unappliedCount || 0

    useEffect(ensureStyleGuideRecommendationsOnOpen, [projectId, scheduleId])

    return (
        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
            <Box component="span">Recommendations</Box>
            <Box
                component="span"
                sx={{
                    display: badgeContent ? "inline-flex" : "none",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: 20,
                    height: 20,
                    px: 0.5,
                    borderRadius: 999,
                    bgcolor: "warning.main",
                    color: "warning.contrastText",
                    fontSize: 12,
                    fontWeight: 700,
                    lineHeight: 1,
                }}
            >
                {badgeContent}
            </Box>
        </Box>
    )

    function ensureStyleGuideRecommendationsOnOpen() {
        if (!projectId || !scheduleId) return
        void ensureStyleGuideAnalysis({ projectId, scheduleId })
            .then(() => refetchRecommendations?.())
            .catch((error) => {
                console.error("Failed to ensure style-guide analysis", error)
            })
    }
}
